import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const TWITTER_SHARE_URL = "https://twitter.com/share?url="
const FB_SHARE_URL = "https://www.facebook.com/sharer.php?u="
const LINKEDIN_SHARE_URL = "https://www.linkedin.com/shareArticle?url="
const REDDIT_SHARE_URL = "https://reddit.com/submit?url="

const HASHTAGS = "FilmTwitter,FilmAndFroth,Movies"

export default function ShareButtons(props) {
  return (
      <div className="flex mx-auto mb-4 md:mb-0 md:mx-0 md:grid md:fixed z-50 right-0 md:left-0 bg-white w-fit">
        <a
          href={
            TWITTER_SHARE_URL +
            props.url +
            "&text=" +
            props.title +
            "&hashtags=" +
            HASHTAGS
          }
          target="_blank"
          rel="noreferrer"
          className="text-black no-underline w-auto"
        >
          <StaticImage
            src="../images/twitter_share.png"
            alt="instagram logo"
            loading="lazy"
            width={40}
          />
        </a>
        <a
          href={FB_SHARE_URL + props.url}
          target="_blank"
          rel="noreferrer"
          className="bg-white text-black no-underline w-auto"
        >
          <StaticImage
            src="../images/facebook_share.png"
            alt="twitter logo"
            loading="lazy"
            width={40}
          />
        </a>
        <a
          href={LINKEDIN_SHARE_URL + props.url + "&title=" + props.title}
          target="_blank"
          rel="noreferrer"
          className="bg-white text-black no-underline w-auto"
        >
          <StaticImage
            src="../images/linkedin_share.png"
            alt="rss logo"
            loading="lazy"
            width={40}
          />
        </a>
        <a
          href={REDDIT_SHARE_URL + props.url + "&title=" + props.title}
          target="_blank"
          rel="noreferrer"
          className="bg-white text-black no-underline w-auto"
        >
          <StaticImage
            src="../images/reddit_share.png"
            alt="rss logo"
            loading="lazy"
            width={40}
          />
        </a>
        <span className="hidden md:grid md:font-bold">Share</span>
      </div>
  )
}
